import * as React from "react";
import { useGridApiContext, useGridSelector, gridPageSelector, gridPageCountSelector } from "@mui/x-data-grid";
import { Pagination } from "@mui/material";
import { grey } from "@mui/material/colors";

// This function generates the default footer styles dynamically
// based on the provided height and background color.
export const getDefaultFooterStyles = (height = 40, backgroundColor = grey[100]) => ({
	// Reduce toolbar height
	"& .MuiDataGrid-toolbarContainer": {
		minHeight: `${height}px !important`,
		height: `${height}px !important`,
		padding: "0px !important",
	},
	// Reduce footer height and apply background color
	"& .MuiDataGrid-footerContainer": {
		minHeight: `${height}px !important`,
		height: `${height}px !important`,
		padding: "0px !important",
		backgroundColor: backgroundColor, // Dynamic background color
		display: "flex", // Ensure flex layout for alignment
		alignItems: "center", // Vertically center content
		justifyContent: "flex-end", // Align pagination to the right
	},
	// Target the TablePagination root within the footer
	"& .MuiTablePagination-root": {
		minHeight: `${height}px !important`,
		height: `${height}px !important`,
		padding: "0px !important",
	},
});

// Custom Pagination component that accepts height and background color props
export function CustomDatagridPagination({ paginationHeight = 40, paginationBgColor = "#eee" }) {
	const apiRef = useGridApiContext();
	const page = useGridSelector(apiRef, gridPageSelector);
	const pageCount = useGridSelector(apiRef, gridPageCountSelector);

	return (
		<Pagination
			count={pageCount}
			page={page + 1}
			size="medium" // Changed to medium for slightly larger icons/text
			onChange={(event, value) => apiRef.current.setPage(value - 1)}
			sx={{
				// Apply background color and height to the root of the Pagination component
				backgroundColor: paginationBgColor, // Dynamic background color
				minHeight: `${paginationHeight}px !important`,
				height: `${paginationHeight}px !important`,
				display: "flex", // Ensure flex layout for alignment
				alignItems: "center", // Vertically center content
				justifyContent: "flex-end", // Align pagination to the right (as per DataGrid default)
				padding: "0 8px", // Add some internal padding

				// Style individual pagination items within the CustomPagination component
				"& .MuiPaginationItem-root": {
					height: paginationHeight * 0.75, // Scale item height relative to paginationHeight
					fontSize: "0.875rem", // Slightly larger font size
					minWidth: paginationHeight * 0.875, // Scale min-width
					margin: "0 3px", // Adjust horizontal spacing between items
				},
				// Target the select input for rows per page dropdown
				"& .MuiInputBase-root": {
					height: paginationHeight * 0.75, // Scale height of the select input
					fontSize: "0.875rem", // Slightly larger font size
					padding: "0 6px", // Adjust padding
				},
				"& .MuiSelect-select": {
					minHeight: "auto", // Override min-height for select to fit new height
				},
				// Style the labels and displayed row count text
				"& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
					fontSize: "0.875rem", // Slightly larger font size for labels and row count
					margin: "0 6px", // Adjust margin for labels
				},
			}}
		/>
	);
}
